export default {
  'search.placeholder': 'Rechercher par nom, lieu, services...',
  'search.results': '{{count}} profils',
  'search.no_results': 'Aucun résultat trouvé pour "{{query}}"',
  'search.clear': 'Effacer la recherche',
  'search.showing': 'Affichage de',
  'search.showing_results': 'Résultats pour "{{query}}"',
  'search.showing_all': 'Affichage de tous les profils',
  'search.results_for': 'résultats pour',
  'search.and': 'et',
  'search.with_filters': 'avec {{count}} filtres actifs',
  'search.active_filters': 'filtres actifs',
  'search.no_profiles_found': 'Aucun profil trouvé',
  'search.no_profiles_message': 'Nous n\'avons trouvé aucun profil pour le moment. Veuillez réessayer plus tard ou ajuster vos critères de recherche.',
  'search.try_again': 'Veuillez essayer un autre terme de recherche ou explorer tous les profils.',

  // New keys to ensure everything is translated
  'filters.from': 'De',
  'filters.to': 'À',
  'profile.verified': 'Vérifié',
  'profile.online': 'En ligne',
  'profile.years': 'ans',
  'profile.touring': 'En tournée',
  'profile.favorite': 'Ajouter aux favoris',
  'profile.unfavorite': 'Retirer des favoris',
  'profile.message': 'Message',
  'profile.tabs.about': 'À propos',
  'profile.tabs.services': 'Services',
  'profile.tabs.rates': 'Tarifs',
  'profile.tabs.contact': 'Contact',
  'profile.services': 'Services proposés',
  'profile.rates': 'Tarifs',
  'profile.contact': 'Informations de contact',
  'profile.no_services': 'Aucun service répertorié',
  'profile.no_rates': 'Aucun tarif répertorié',
  'profile.generating_image': 'Génération de l\'image en cours...',
  'profile.various_durations': 'Différentes durées',
  'profileManagement.admin_tools': 'Outils d\'administration',

  // Clés manquantes des logs
  'search.filter_results': 'Filtrer les résultats',
  'search.reset_filters': 'Réinitialiser les filtres',
  'search.all_genders': 'Tous les genres',
  'search.min_age': 'Âge min',
  'search.max_age': 'Âge max',
  'search.status': 'Statut',
  'search.verified_only': 'Vérifié uniquement',
  'search.online_only': 'En ligne uniquement',

  // Search keys from new logs
  'search.search_placeholder': 'Rechercher par nom, lieu, services...',
  'search.filters': 'Filtres',

  // Adding simple keys based on log errors (missing namespace prefix in code?)
  'search_placeholder': 'Rechercher par nom, lieu, services...',
  'filters': 'Filtres'
};
